/* Roulette wheel presentation extracted from CasinoCefPage. */
export const ROULETTE_WHEEL = [0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26];
export const REDS = new Set([1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36]);
export const numColor = (n) => (n === 0 ? "#16a34a" : REDS.has(n) ? "#dc2626" : "#18181b");
const GOLD = "#d4af37";
const STEP = 360 / 37;
const fmt = (n) => `$${Number(n).toLocaleString()}`;

export default function RouletteWheel({ rotation, ballRot, ballIn, spinning, rouletteResult }) {
  return (
    <div className="relative shrink-0" style={{ width: "min(430px, 38vw)", height: "min(430px, 38vw)", minWidth: 320, minHeight: 320 }}>
      <div className="absolute inset-0 rounded-full" style={{ background: "radial-gradient(circle, #3a2b12 0%, #241a0a 60%, #171006 100%)", boxShadow: "0 0 60px #000000cc, inset 0 0 40px #000000" }} />
      <svg data-testid="roulette-wheel" viewBox="0 0 360 360" className="absolute inset-0"
        style={{ transform: `rotate(${rotation}deg)`, transition: spinning ? "transform 4.4s cubic-bezier(0.12, 0.8, 0.16, 1)" : "none" }}>
        {ROULETTE_WHEEL.map((n, i) => (
          <g key={n} transform={`rotate(${i * STEP} 180 180)`}>
            <path d="M 180 180 L 168 24 A 158 158 0 0 1 192 24 Z" fill={numColor(n)} stroke="#d4af3744" strokeWidth="0.6" />
            <text x="180" y="42" textAnchor="middle" fill="#fafafa" fontSize="11" fontFamily="monospace" fontWeight="700">{n}</text>
          </g>
        ))}
        <circle cx="180" cy="180" r="98" fill="#1c1409" stroke="#d4af3766" strokeWidth="1.5" />
        <circle cx="180" cy="180" r="58" fill="#241a0a" stroke={GOLD} strokeWidth="1" />
        <text x="180" y="176" textAnchor="middle" fill={GOLD} fontSize="13" fontFamily="monospace" letterSpacing="2">GILDED</text>
        <text x="180" y="193" textAnchor="middle" fill={GOLD} fontSize="13" fontFamily="monospace" letterSpacing="2">SPADE</text>
      </svg>
      <div className="absolute left-1/2 -translate-x-1/2 -top-1 z-20" style={{ borderLeft: "8px solid transparent", borderRight: "8px solid transparent", borderTop: `14px solid ${GOLD}` }} />
      <div className="absolute left-1/2 top-1/2 z-10 pointer-events-none" style={{
        transform: `rotate(${ballRot}deg) translateY(${ballIn ? -118 : -152}px)`,
        transition: spinning ? "transform 4.4s cubic-bezier(0.12, 0.8, 0.16, 1)" : "transform 0.8s ease",
      }}>
        <div className="w-3 h-3 -ml-1.5 -mt-1.5 rounded-full bg-zinc-100" style={{ boxShadow: "0 0 8px #ffffffaa" }} />
      </div>
      {rouletteResult && !spinning && (
        <div data-testid="roulette-result" className="absolute inset-x-8 top-1/2 -translate-y-1/2 z-30 text-center py-3 border backdrop-blur-sm"
          style={{ backgroundColor: "#000000cc", borderColor: rouletteResult.payout > 0 ? "#34d39966" : "#ef444466", animation: "ncFadeUp 0.4s ease both" }}>
          <p className="font-black text-3xl" style={{ color: numColor(rouletteResult.result) === "#18181b" ? "#fafafa" : numColor(rouletteResult.result) }}>{rouletteResult.result}</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em]" style={{ color: rouletteResult.payout > 0 ? "#34d399" : "#ef4444" }}>
            {rouletteResult.payout > 0 ? `+${fmt(rouletteResult.payout)}` : `-${fmt(rouletteResult.stake)}`}
          </p>
        </div>
      )}
    </div>
  );
}
